import React, { useState } from "react"
import { Heading } from "../common/Heading"
import { portfolio } from "../data/dummydata"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import salon from "./Images/1.png";
import food from "./Images/2.png";
import mall from "./Images/3.png";
import train from "./Images/4.png";

const allCategory = ["all", ...new Set(portfolio.map((item) => item.category))]
export const Portfolio = () => {
  const [list, setLists] = useState(portfolio)
  const [category, setCategory] = useState(allCategory)
  console.log(setCategory)

  const filterItems = (category) => {
    const newItems = portfolio.filter((item) => item.category === category)
    setLists(newItems)
    if (category === "all") {
      setLists(portfolio)
      return
    }
  }

  return (
    <>
      <article>
        <div className='container'>
          <Heading title='Projects' />
          <div className='catButton'>
            {/* {category.map((category) => (
              <button className='primaryBtn' onClick={() => filterItems(category)} data-aos='zoom-out-down'>
                {category}
              </button>
            ))} */}
            <button className='primaryBtn' data-aos='zoom-out-down'>
                All
              </button>
          </div>
          <div className='content grid3'>
            {/* {list.map((item) => ( */}
              <div className='box2' data-aos='fade-up'>
                <div className='img'>
                  <img src={salon} alt='' />
                </div>
                <div className='overlay'>
                  <h3>Salon Management</h3>
                  <span>system</span>
                  <VisibilityOutlinedIcon />
                </div>
              </div>
              {/* second project */}
              <div className='box2' data-aos='fade-up'>
                <div className='img'>
                  <img src={food} alt='' />
                </div>
                <div className='overlay'>
                  <h3>Food Waste Management</h3>
                  <span>system</span>
                  <VisibilityOutlinedIcon />
                </div>
              </div>
              {/* third project */}
              <div className='box2' data-aos='fade-up'>
                <div className='img'>
                  <img src={mall} alt='' />
                </div>
                <div className='overlay'>
                  <h3>Online Shopping Mall</h3>
                  <span>system</span>
                  <VisibilityOutlinedIcon />
                </div>
              </div>
              {/* fourth project */}
              <div className='box2' data-aos='fade-up'>
                <div className='img'>
                  <img src={train} alt='' />
                </div>
                <div className='overlay'>
                  <h3>Train Reservation</h3>
                  <span>system</span>
                  <VisibilityOutlinedIcon />
                </div>
              </div>
            {/* ))} */}
          </div>
        </div>
      </article>
    </>
  )
}
